import type {components} from "#open-fetch-schemas/nest-main";

export const useHttpStore = defineStore('http', () => {
    const {$nestMain} = useNuxtApp()
    const apiPath: Ref<string> = ref(useRuntimeConfig().public.API_PATH as string)
    const staticPath: Ref<string> = ref(useRuntimeConfig().public.NUXT_STATIC_PATH as string)
    const staticFilesPath: Ref<string> = ref(useRuntimeConfig().public.STATIC_FILES_PATH as string)
    const domainGroupObj = ref<{ id: number, name: string }>()
    const pendingLogout = ref(false)
    const domain = computed(() => {
        if (import.meta.server) {
            let headers = useRequestHeaders(['host']) as { host: string }
            return headers.host.split(':')[0]
        } else {
            return window.location.host.split(':')[0]
        }
    })

    async function getDomainGroup() {
        return await $nestMain('/main/domain-group')
    }

    async function getCategories() {
        return await $nestMain('/main/categories')
    }

    async function getParentProductType(id: number) {
        return await $nestMain('/main/getParentProductType', {method: 'POST', query: {id: id}})
    }

    async function meiliProductSubTypeSearch(search: string, locale: string) {
        const body = {search: search, lang: locale} as unknown as components['schemas']['fullTextSearchDTO']

        return await $nestMain('/meili/Search/ProductSubType', {
            method: 'POST',
            body: body
        })
    }

    async function getPTypes() {
        return await $nestMain('/main/ptypes')
    }


    return {
        apiPath, pendingLogout, getCategories, getParentProductType, meiliProductSubTypeSearch, domain,
        getPTypes,
        staticPath,
        staticFilesPath,
        domainGroupObj,
        getDomainGroup,
    }

})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useHttpStore, import.meta.hot))
}
